import { Box } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { selectProgress } from '../../store/Slices/loading';
import { ENUM_EVENT } from '../../utils/eventEmitter';
import ProcessingLoader from '../ProcessingLoader';

const Layout = ({ children }) => {
    const { isLoading, isParent } = useSelector(selectProgress);
    const [loading, setLoading] = useState(false);
    const location = useLocation();

    const blockLoaderRef = useRef(false);
    const justSignaledRef = useRef(false);

    useEffect(() => {
        justSignaledRef.current = false;
        const graceId = setTimeout(() => {
            if (justSignaledRef.current) return;
            setLoading(false);
            blockLoaderRef.current = true;
            setTimeout(() => { blockLoaderRef.current = false; }, 300);
        }, 50);
        return () => clearTimeout(graceId);
    }, [location.pathname]);

    useEffect(() => {
        setLoading(isLoading);
    }, [isLoading])

    useEffect(() => {
        const handleLoadingEvent = (event) => {
            if (blockLoaderRef.current && event?.detail?.loading) return;
            justSignaledRef.current = !!event?.detail?.loading;
            setLoading(event?.detail?.loading);
        };

        window.addEventListener(ENUM_EVENT.LOADER, handleLoadingEvent);
        return () => {
            window.removeEventListener(ENUM_EVENT.LOADER, handleLoadingEvent);
        };
    }, []);

    return (
        <div className="layout">
            {loading && <ProcessingLoader />}
            {children}
        </div>
    );
}

export default Layout